export default {
    getInterval(list, key, qty){
        const initial = key === 1 ? 0 : ( key -1 ) * qty;
        const next = initial + qty;
        const size = next > list.length ? list.length : next; 
        
        return list.slice(initial, size);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/list.js